import {
    faCaretDown,
    faCaretUp,
    faExclamationTriangle,
    faHeart,
    faHospital,
    faDatabase,
    faExclamationCircle,
    faTimes,
    faCheckCircle,
    faPencil,
    faCircle,
    faCheck
} from '@fortawesome/pro-solid-svg-icons'

export default [
    faHeart,
    faExclamationTriangle,
    faExclamationCircle,
    faTimes,
    faCheckCircle,
    faCaretUp,
    faCaretDown,
    faHospital,
    faDatabase,
    faPencil,
    faCircle,
    faCheck
]
